<template>
  <RouterLink :to="to" class="nav-item hover:bg-[#25B0D725] hover:scale-115 active:scale-100" :class="{ active: $route.path === to }">
    <component
      v-if="icon"
      :is="icon"
      class="icon"
      :class="{ 'icon-active': $route.path === to, 'icon-inactive': $route.path !== to }"
    />
    <span
      class="nav-title text-center break-words whitespace-normal leading-tight"
      :class="{ 'title-active': $route.path === to, 'title-inactive': $route.path !== to }"
    >
      {{ title }}
    </span>
  </RouterLink>
</template>

<script setup>
import { defineProps } from 'vue'

defineProps({
  to: String,
  icon: Object,
  title: String
})
</script>

<style scoped>
.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 10px;
  transition: background-color 0.3s ease;
}

.nav-item.active {
  background-color: #59E3FF;
  /* transition: color 0.6s ease-in-out; */
}

/* Icon Styles */
.icon {
  width: 40px;
  height: 35px;
  transition: color 0.3s ease-in-out;
}

.icon-inactive {
  color: #25B0D7;
}

.icon-active {
  color: #ffffff;
}

/* Title styles */
.nav-title {
  margin-top: 5px;
  margin-left: 0;
  white-space: normal;
  word-break: break-word;
  opacity: 1;
  font-size: var(--readable-label-size);
  font-weight: var(--readable-label-weight);
  text-align: center;
  width: 100%;
  /* transition: color 0.3s ease; */
}

.title-inactive {
  color: var(--readable-label-color);
}

.title-active {
  color: #ffffff;
}
</style>
